import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/case/view/$id/medical-note/")({
	beforeLoad: ({ params }) => {
		return redirect({
			to: "/dashboard/case/view/$id/detail",
			// @ts-expect-error
			params,
			search: {
				// @ts-expect-error
				tab: "medical_notes",
			},
		});
	},
});
